import React, {useId, type ReactNode} from "react";
import "./index.css";

export function DefaultsMenu({setLabel, expanded, onExpandedChange, navigation, children}: {
  setLabel: string;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  navigation?: ReactNode;
  children?: ReactNode;
}) {
  const bodyId = useId();
  return <div className={`default-scene-panel ${expanded ? "" : "is-collapsed"}`}>
    <button type="button" className="default-scene-toggle" onClick={() => onExpandedChange(!expanded)} aria-expanded={expanded} aria-controls={bodyId}>
      <span className="label">Defaults: {setLabel}</span>
      <span className="default-scene-toggle-icon" aria-hidden="true">{expanded ? "Collapse" : "Expand"}</span>
    </button>
    <div id={bodyId} hidden={!expanded}>
      {expanded && navigation}
      {children}
    </div>
  </div>;
}
